import dayjs from "dayjs";
import React, { useMemo, useState } from "react";

//src
import { isSomething } from "../../../utils/utils";
import { Button } from "../../../components/button/button";
import { NoDataStateStyled } from "./no-data-state.style";
import SelectField from "../../../components/form-fields/select-field/select-field";
import DatePicker from "../../../components/form-fields/date-picker/date-picker";
import { PLANNER_TYPES } from "../planner.constants";
import { Typography } from "@mui/material";

const NoDataState = ({
  templatesList = [],
  onStartFromScratch,
  onTemplateSelection,
  onPlannerTypeChange,
}) => {
  const [startState, setStartState] = useState("scratch");
  const [selectedPlannerType, setSelectedPlannerType] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [startDate, setStartDate] = useState("");

  const isScratch = startState === "scratch";
  const isTemplate = startState === "template";

  // Filter templates by chosen planner type
  const templateOptions = useMemo(() => {
    if (!selectedPlannerType) return [];
    return (
      templatesList
        .filter((t) => t.data?.plannerType === selectedPlannerType)
        .map((t) => ({ label: t.name, value: t.name })) || []
    );
  }, [templatesList, selectedPlannerType]);

  const handleStartDateChange = (date) => {
    if (!date) return setStartDate("");
    setStartDate(dayjs(date).format("YYYY-MM-DD"));
  };

  const handlePlannerTypeSelect = (e) => {
    const type = e.target.value;
    setSelectedPlannerType(type);
    onPlannerTypeChange?.(type);
    // reset template selection when planner type changes
    setSelectedTemplate("");
  };

  const handleTemplateCreate = () => {
    const template = templatesList.find((t) => t.name === selectedTemplate);
    onTemplateSelection(template, startDate);
  };

  return (
    <NoDataStateStyled>
      <div className="no-data-state">
        <div className="templateHeading">
          <Typography variant="h6">How would you like to begin?</Typography>
        </div>
        <div className="options">
          {/* Start mode selector */}
          <SelectField
            value={startState}
            options={[
              { label: "Start from Scratch", value: "scratch" },
              { label: "Choose a Template", value: "template" },
            ]}
            placeholder="Please Select"
            onChange={(e) => setStartState(e.target.value)}
          />

          {/* Planner type selector */}
          <SelectField
            label="Planner Type"
            value={selectedPlannerType}
            options={PLANNER_TYPES}
            placeholder="Please Select Type"
            onChange={handlePlannerTypeSelect}
          />

          {/* Scratch path */}
          {isScratch && (
            <Button
              onClick={() => onStartFromScratch(selectedPlannerType)}
              disabled={!isSomething(selectedPlannerType)}
              size="large"
              variant="filled"
              color="tertiary"
            >
              Create Project Plan
            </Button>
          )}

          {/* Template path */}
          {isTemplate && (
            <>
              <SelectField
                label="Templates"
                value={selectedTemplate}
                options={templateOptions}
                placeholder="Select Template"
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
              <DatePicker
                label="Start Date"
                value={startDate}
                placeholder="YYYY-MM-DD"
                onChange={handleStartDateChange}
                description="Select a start date to adjust all dates in the template."
              />
              <Button
                onClick={handleTemplateCreate}
                disabled={!isSomething(selectedTemplate)}
                size="large"
                variant="filled"
                color="tertiary"
              >
                Create Project Plan
              </Button>
            </>
          )}
        </div>
      </div>
    </NoDataStateStyled>
  );
};

export default NoDataState;
